import React from 'react';
import { makeStyles } from '@mui/styles';
import { Card, AppBar, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ListServiceSets from './ListServiceSets';
import CreateServiceSet from './CreateServiceSet';
import { useStyles } from './style';
export function ServiceSet(props) {
    const classes = useStyles();

    const [value, setValue] = React.useState('list');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <Card>
                <TabContext value={value}>
                    <AppBar position="static">
                        <TabList onChange={handleChange}>
                            <Tab label="لیست مجموعه سرویس ها" value="list" style={{ fontSize: '12px' }} />
                            <Tab label="ایجاد مجموعه سرویس" value="create" style={{ fontSize: '12px' }} />
                        </TabList>
                    </AppBar>
                    <TabPanel value="create">
                        <CreateServiceSet />
                    </TabPanel>
                    <TabPanel value="list">
                        <ListServiceSets />
                    </TabPanel>
                </TabContext>
            </Card>
        </div>
    );
};

